<template>
  <div>
    <preamble v-bind="preamble" />
    <pop v-bind="popContent" v-on:popClose="closePop" />
    <section class="main">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div v-if="chapters < 1" class="columns">
                        <div class="column is-12">
                            <div class="chapter">
                                <div>
                                    <h3>Loading...</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-4" v-for="(chapter,index) in chapterRowOne" :key="index">
                            <div class="chapter" @click="gotoChapter(chapter.id)">
                                <div>
                                    <h3>{{ chapter.title}}</h3>
                                    <h5>{{ chapter.chapter}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-4" v-for="(chapter,index) in chapterRowTwo" :key="index">
                            <div class="chapter" @click="gotoChapter(chapter.id)">
                                <div>
                                    <h3>
                                        {{ chapter.title}}
                                    </h3>
                                    <h5>{{ chapter.chapter}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-4" v-for="(chapter,index) in chapterRowThree" :key="index">
                            <div class="chapter" @click="gotoChapter(chapter.id)">
                                <div>
                                    <h3>
                                        {{ chapter.title}}
                                    </h3>
                                    <h5>{{ chapter.chapter}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    //import Router from 'vue-router'
    import Preamble from '@/components/Preamble.vue'
    import Pop from '@/components/Pop.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources } from '@/utils/constants'

    export default {
        name: "Chapters",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble, Pop    
                },
        data() {
            return {
              // triggered: true,
              chapters: [],
              preamble: {
                title: 'Chapters',
                subTitle: 'ALL CHAPTERS',
                description: '<p>In the 1980’s and 1990’s, behavioral change communication (BCC) campaigns were effective in reducing the spread of HIV in Uganda and eventually the country was recognized internationally for its efforts in the fight against the epidemic. Through showcasing materials collected over the last 30 years of the HIV response in Uganda, this online platform seeks to bring together research and lived experiences to showcase the many textures of HIV advocacy and outreach. </p><p>As the epidemic matured, HIV organisations were established, treatments were developed and new national and international strategies for controlling and managing HIV were rolled out. Scholars and practitioners believe these materials could be used to stimulate a dialogue with those at risk of infection and living with HIV today. Many younger people may be complacent about HIV as they have not lived through the times when HIV was killing thousands of people weekly before effective treatment was available. We invite you to participate in this immersive experience that belongs both to the country and the individuals who lived through it. We invite you to interact with this rich history, to learn from it and to unite in the struggle to end HIV/AIDS in Uganda.</p>',
                watchVideo: '',

              },
              popContent: {
                triggered: false,
                title: 'The disease now has a name: "Slim"',
                description: 'In Uganda, during the 1980’s and 1990’s behavioural change communication (BCC) campaigns were effective in reducing the spread of HIV. Many younger people may be complacent about HIV as they have not lived through the times when HIV was killing thousands of people weekly before effective treatment was available.',
              },
              currentLine: {
                id: '101',
                year: '1968',
                title: 'The disease now has a name: "Slim"',
                shortDescription: '“A neighbour and later her boyfriend die in Makindye after suffering from a strange disease”. First memories of a strange disease manifesting symptoms similar to AIDS.',
                longDescription: '', // will come back to this
                image: '' // will come back to this
              },
            }
        },
        created() {
          
          //Fetch timeline items 
          this.read(`${resources.chapter}`)
            .then(response => {
              this.chapters = response.data
          })
        
        },
        mounted() {
            
        },
        methods: {
          gotoChapter(id) {
            this.$router.push({ name: 'Chapter', params: { id } })
          },

          handlePop() {
            this.popContent = {...this.currentLine, triggered: true}
          },

          closePop() {
            this.popContent.triggered = false;
          }
        },
        computed: {
            chapterRowOne() {
                return this.chapters.slice(0, 3);
            },
            chapterRowTwo() {
                return this.chapters.slice(3, 6);
            },
            chapterRowThree() {
                return this.chapters.slice(6, 9);
            }
        },
    }
</script>

<style>
</style>
